import app from "./firebase";

const functions = app.functions();

if(process.env.NODE_ENV === "development") {    
    functions.useEmulator("localhost", 5001);
}


export default functions;